import './styles/index.scss'
import { App } from 'vue'
import { i18n } from '@/plugins/i18n'

import { IComponent } from './types/global'
import Alert from './components/alert'
import Avatar from './components/avatar'
import AvatarGroup from './components/avatar-group'
import Blueprint from './components/blueprint'
import Breadcrumbs from './components/breadcrumbs'
import Button from './components/button'
import ButtonGroup from './components/button-group'
import Badge from './components/badge'
import Calendar from './components/calendar'
import Card from './components/card'
import Checkbox from './components/checkbox'
import CheckboxGroup from './components/checkbox-group'
import Chip from './components/chip'
import ChoiceChips from './components/choice-chips'
import RuleEditor from './components/rule-editor'
import Collapse from './components/collapse'
import CollapseItem from './components/collapse-item'
import DataTable from './components/datatable'
import DatePicker from './components/datepicker'
import DateRangePicker from './components/daterangepicker'
import DateTimePicker from './components/datetimepicker'
import Divider from './components/divider'
import Drawer from './components/drawer'
import Dropdown from './components/dropdown'
import Editor from './components/editor'
import EmailInput from './components/emailinput'
import FlipCard from '@/components/flip-card'
import Grid from './components/grid'
import GuidedTour from './components/guidedtour'
import FilePicker from './components/filepicker'
import Icon from './components/icon'
import Input from './components/input'
import InputList from './components/inputlist'
import Label from './components/label'
import List from './components/list'
import Loading from './components/loading'
import Loadingbar from './components/loadingbar'
import LoadingCircle from './components/loadingcircle'
import Message from './components/message'
import Modal from './components/modal'
import Notification from './components/notification'
import NumberInput from './components/numberinput'
import NumberRangePicker from './components/numberrangepicker'
import OptionsGroup from './components/options-group'
import PhoneInput from './components/phoneinput'
import Popover from './components/popover'
import Progressbar from './components/progressbar'
import Radio from './components/radio'
import RadioGroup from './components/radiogroup'
import Select from './components/select'
import Slider from './components/slider'
import SocialSecurityInput from './components/socialsecurityinput'
import Spinner from './components/spinner'
import Switch from './components/switch'
import Tabs from './components/tabs'
import Tab from './components/tab'
import Tag from './components/tag'
import Textarea from './components/textarea'
import Theme from './components/theme'
import TimePicker from './components/timepicker'
import Toggle from './components/toggle'
import Tooltip from './components/tooltip'
import Tree from './components/tree'
import UrlInput from './components/urlinput'
import ZipInput from './components/zipinput'
import useFadeInDirective from './directives/effects/loadFadeIn'
import Fragment from './components/fragment'

const components = {
  Alert,
  Avatar,
  AvatarGroup,
  Badge,
  Blueprint,
  Breadcrumbs,
  Button,
  ButtonGroup,
  Calendar,
  Card,
  Checkbox,
  ...CheckboxGroup,
  RuleEditor,
  Collapse,
  CollapseItem,
  Chip,
  ChoiceChips,
  // ColorPicker,
  ...DataTable,
  DatePicker,
  DateRangePicker,
  DateTimePicker,
  Divider,
  Drawer,
  ...Dropdown,
  Editor,
  EmailInput,
  FlipCard,
  Grid,
  GuidedTour,
  FilePicker,
  Icon,
  Input,
  InputList,
  Label,
  List,
  Loading,
  LoadingCircle,
  Modal,
  NumberInput,
  NumberRangePicker,
  OptionsGroup,
  PhoneInput,
  Popover,
  Progressbar,
  Radio,
  RadioGroup,
  ...Select,
  Slider,
  SocialSecurityInput,
  Spinner,
  Switch,
  Tabs,
  Tab,
  Tag,
  Textarea,
  Theme,
  TimePicker,
  Toggle,
  Tooltip,
  Tree,
  UrlInput,
  ZipInput,
  Fragment,
}

function install(Vue: App, options?: Record<string, unknown> | null) {
  for (const component in components) {
    Vue.component(components[component].name, components[component])
  }
  Vue.config.globalProperties.$Theme = options
  Vue.config.globalProperties.$Message = Message
  Vue.config.globalProperties.$Notification = Notification
  Vue.config.globalProperties.$Loading = Loadingbar
  Vue.config.globalProperties.$LpComponents = {
    drawers: [],
    modals: [],
  } as IComponent
  Vue.provide('customTheme', options ?? null)
  Vue.config.globalProperties.$Theme = options ?? null
  const loadFadeIn = useFadeInDirective()
  Vue.directive('load-fade-in', loadFadeIn)
  Vue.use(i18n)
}

export default { install }

export { default as Alert } from './components/alert'
export { default as Avatar } from './components/avatar'
export { default as AvatarGroup } from './components/avatar-group'
export { default as Badge } from './components/badge'
export { default as Blueprint } from './components/blueprint'
export { default as Breadcrumbs } from './components/breadcrumbs'
export { default as Button } from './components/button'
export { default as ButtonGroup } from './components/button-group'
export { default as Calendar } from './components/calendar'
export { default as Card } from './components/card'
export { default as Checkbox } from './components/checkbox'
export { default as CheckboxGroup } from './components/checkbox-group'
export { default as Chip } from './components/chip'
export { default as ChoiceChips } from './components/choice-chips'
export { default as RuleEditor } from './components/rule-editor'
export { default as Collapse } from './components/collapse'
export { default as CollapseItem } from './components/collapse-item'
export { default as DataTable } from './components/datatable'
export { default as DatePicker } from './components/datepicker'
export { default as DateRangePicker } from './components/daterangepicker'
export { default as DateTimePicker } from './components/datetimepicker'
export { default as Divider } from './components/divider'
export { default as Drawer } from './components/drawer'
export { default as Dropdown } from './components/dropdown'
export { default as Editor } from './components/editor'
export { default as EmailInput } from './components/emailinput'
export { default as Grid } from './components/grid'
export { default as GuidedTour } from './components/guidedtour'
export { default as FilePicker } from './components/filepicker'
export { default as Icon } from './components/icon'
export { default as Input } from './components/input'
export { default as InputList } from './components/inputlist'
export { default as Label } from './components/label'
export { default as List } from './components/list'
export { default as Loading } from './components/loading'
export { default as Loadingbar } from './components/loadingbar'
export { default as LoadingCircle } from './components/loadingcircle'
export { default as Message } from './components/message'
export { default as Modal } from './components/modal'
export { default as Notification } from './components/notification'
export { default as NumberInput } from './components/numberinput'
export { default as NumberRangePicker } from './components/numberrangepicker'
export { default as OptionsGroup } from './components/options-group'
export { default as PhoneInput } from './components/phoneinput'
export { default as Popover } from './components/popover'
export { default as Progressbar } from './components/progressbar'
export { default as Radio } from './components/radio'
export { default as RadioGroup } from './components/radiogroup'
export { default as Select } from './components/select'
export { default as Slider } from './components/slider'
export { default as SocialSecurityInput } from './components/socialsecurityinput'
export { default as Spinner } from './components/spinner'
export { default as Switch } from './components/switch'
export { default as Tabs } from './components/tabs'
export { default as Tab } from './components/tab'
export { default as Tag } from './components/tag'
export { default as Textarea } from './components/textarea'
export { default as Theme } from './components/theme'
export { default as TimePicker } from './components/timepicker'
export { default as Toggle } from './components/toggle'
export { default as Tooltip } from './components/tooltip'
export { default as Tree } from './components/tree'
export { default as UrlInput } from './components/urlinput'
export { default as ZipInput } from './components/zipinput'
export { default as Fragment } from './components/fragment'

const logo = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="162" height="27"><defs><path id="a" d="M0 0h18.319v26.242H0z"/><path id="c" d="M0 0h4.335v4.569H0z"/></defs><g fill="none" fill-rule="evenodd"><path fill="#FF9100" d="M22.989.326a3.27 3.27 0 1 1-.001 6.539 3.27 3.27 0 0 1 0-6.539M13.13.326a3.27 3.27 0 1 1-.001 6.54 3.27 3.27 0 0 1 0-6.54M3.27.326a3.27 3.27 0 1 1 0 6.54 3.27 3.27 0 0 1 0-6.54"/><path fill="#FF9100" d="M37.466 22.43V.284h-4.643v26.242h14.596V22.43zM56.906 26.82c-5.368 0-9.177-4.02-9.177-9.977 0-5.958 3.809-9.978 9.177-9.978 5.368 0 9.178 4.02 9.178 9.978s-3.81 9.977-9.178 9.977m0-3.691c2.94 0 4.788-2.376 4.788-6.286 0-3.91-1.849-6.287-4.788-6.287-2.938 0-4.787 2.376-4.787 6.287 0 3.91 1.849 6.286 4.787 6.286M87.67 7.34h4.352v2.047c1.089-1.279 2.793-2.412 5.26-2.412 3.99 0 6.383 2.777 6.383 6.907v12.646h-4.352V15.161c0-2.374-.943-4.093-3.336-4.093-1.96 0-3.955 1.463-3.955 4.203v11.257H87.67V7.34ZM138.215 11.69c-.544-.074-.98-.11-1.596-.11-2.757 0-4.86 1.79-4.86 4.86v10.088h-4.354V7.34h4.354v2.85c.834-1.79 2.792-2.96 5.223-2.96.507 0 .906.038 1.233.074v4.385ZM148.428 26.82c-5.337 0-9.123-4.02-9.123-9.977 0-5.958 3.786-9.978 9.123-9.978s9.122 4.02 9.122 9.978-3.785 9.977-9.122 9.977m0-3.691c2.92 0 4.76-2.376 4.76-6.286 0-3.91-1.84-6.287-4.76-6.287-2.921 0-4.76 2.376-4.76 6.287 0 3.91 1.839 6.286 4.76 6.286"/><g transform="translate(106.621 .283)"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#FF9100" d="M8.89 0H0v26.242h4.643V15.194H8.89c5.803 0 9.43-2.37 9.43-7.597C18.32 2.297 14.692 0 8.89 0m-.254 11.174H4.643V4.02h3.993c3.336 0 5.113.983 5.113 3.577 0 2.558-1.777 3.577-5.113 3.577" mask="url(#b)"/></g><path fill="#FF9100" d="M67.509 21.119c0-3.655 2.72-5.263 6.384-6.031l5.26-1.096v-.329c0-1.828-.944-2.96-3.265-2.96-2.067 0-3.156.95-3.663 2.814l-4.1-.95c.944-3.18 3.737-5.665 7.944-5.665 4.57 0 7.327 2.192 7.327 6.615v8.26c0 1.097.472 1.425 1.669 1.28v3.397c-3.156.367-4.824-.255-5.478-1.827-1.196 1.352-3.192 2.156-5.658 2.156-3.626 0-6.42-2.23-6.42-5.664Zm11.644-4.02-4.1.877c-1.849.402-3.228.987-3.228 2.705 0 1.498 1.088 2.34 2.758 2.34 2.32 0 4.57-1.244 4.57-3.584v-2.339Z"/><path fill="#FF9100" d="M13.076 20.014a3.255 3.255 0 1 1 0 6.509 3.255 3.255 0 0 1 0-6.51M3.263 20.014a3.255 3.255 0 1 1 0 6.509 3.255 3.255 0 0 1 0-6.51M13.13 10.185a3.27 3.27 0 1 1-.001 6.54 3.27 3.27 0 0 1 0-6.54M3.27 10.185a3.27 3.27 0 1 1 0 6.54 3.27 3.27 0 0 1 0-6.54"/><g transform="translate(157.592 22.25)"><mask id="d" fill="#fff"><use xlink:href="#c"/></mask><path fill="#27313F" d="M1.627 2.266h.625a.693.693 0 0 0 .473-.156.511.511 0 0 0 .178-.405c0-.2-.052-.343-.157-.428-.104-.086-.276-.13-.514-.135h-.605v1.124Zm0 .17v1.075h-.168V.977h.73c.587 0 .882.244.882.733 0 .293-.156.502-.466.629.268.079.402.29.402.634 0 .227.017.389.052.49v.048h-.18c-.03-.074-.043-.252-.043-.538 0-.187-.04-.322-.118-.405-.078-.084-.213-.127-.404-.132h-.687Zm-1.46-.155c0 .378.089.732.266 1.059.176.327.42.587.73.778.308.192.644.287 1.004.287.358 0 .693-.095 1.001-.287.31-.19.554-.451.73-.778a2.19 2.19 0 0 0 .266-1.06c0-.38-.089-.733-.266-1.06a2.014 2.014 0 0 0-.731-.77 1.89 1.89 0 0 0-1-.285c-.358 0-.692.095-1.003.285-.31.189-.555.446-.73.77a2.181 2.181 0 0 0-.267 1.06ZM0 2.28c0-.411.095-.793.284-1.145.19-.352.454-.63.791-.832A2.077 2.077 0 0 1 2.167 0c.392 0 .755.1 1.092.304.337.203.6.48.79.832.191.352.286.734.286 1.145 0 .405-.093.782-.278 1.132-.184.35-.447.63-.783.841a2.045 2.045 0 0 1-1.107.315c-.4 0-.77-.103-1.107-.315a2.182 2.182 0 0 1-.782-.84A2.389 2.389 0 0 1 0 2.28Z" mask="url(#d)"/></g></g></svg>`
const logoDataUrl = `data:image/svg+xml;base64,${btoa(logo)}`

// @todo: check if it's safe to change it to `production`
if (import.meta.env.MODE !== 'test') {
  // eslint-disable-next-line no-console
  console.info(
    // `%cLoanPro UI ${import.meta.env.PACKAGE_VERSION}`,
    `%c UI ${APP_VERSION}`,
    `background-size: 50% ;background-position: left center;background-repeat: no-repeat;color: #FF9100; background-image: url(${logoDataUrl}); font-family: Roboto, sans-serif; font-weigth: 700; font-size: 1rem; padding: 1rem 2rem 1rem 7rem;`,
  )
}
